<template>
  <div class="page">
    <div class="logo">
      <img src="@/assets/logo.png" />
      <div>不舒服，点点我！</div>
      <div>哪里不舒服，就点哪里！</div>
    </div>
    <div v-if="inviteCode"
         class="invite">邀请码：{{inviteCode}}<span class="copy"
            v-clipboard:copy="inviteCode"
            v-clipboard:success="copySuccess"
            v-clipboard:error="copyError">复制</span></div>
    <button class="btn-theme"
            @click="goDownload">立即下载</button>
    <!-- 提示层 -->
    <div class="weixin-tip"
         id="tip">
      <div class="content">
        <img src="@/assets/live_weixin.png" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast } from 'vant'
import 'vant/lib/toast/style'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.use(Toast)

export default {
  name: 'Download',
  data() {
    return {
      inviteCode: null,
      androidUrl: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.hexagon.medicalpioneer&g_f=1000047',
      iosUrl: 'https://apps.apple.com/cn/app/id1558059417'
    }
  },
  created() {
    this.inviteCode = this.$route.query.inviteCode
  },
  methods: {
    is_weixin() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    copySuccess() {
      Toast('复制成功')
    },
    copyError() {
      Toast('复制失败，请重试！')
    },
    goDownload() {
      var ua = navigator.userAgent;
      var isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (this.is_weixin() && isiOS) {
        document.getElementById('tip').style.display = 'block';
      } else {
        if (isiOS) {
          location.href = this.iosUrl;
        } else {
          location.href = this.androidUrl;
        }
      }
    }
  }
}
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background-color: white;
}

.logo {
  text-align: center;
  color: #a4a6bc;
  font-size: 13px;
}

.logo img {
  width: 88px;
  height: 88px;
  margin-bottom: 10px;
}

.invite {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 0;
  font-size: 20px;
  font-weight: bold;
  color: #0063aa;
}

.copy {
  height: 20px;
  line-height: 20px;
  padding: 1px 10px;
  margin-left: 10px;
  font-size: 12px;
  color: #999;
  border: 1px solid #aaa;
  border-radius: 20px;
}

.btn-theme {
  display: block;
  width: 50vw;
  height: 40px;
  margin: 30px auto;
  color: white;
  font-size: 14px;
  background-color: #0063aa;
  border: none;
  border-radius: 40px;
}

.weixin-tip {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  filter: alpha(opacity=80);
  height: 100%;
  width: 100%;
  z-index: 9999;
}

.weixin-tip img {
  width: 100%;
}

.weixin-tip .content {
  text-align: center;
  margin-top: 1%;
  padding: 0 5%;
}
</style>